import * as firebase from 'firebase/app'
import 'firebase/auth'
import 'firebase/firestore'

// firebase init
const firebaseConfig = {
  apiKey: "AIzaSyDrJB0WnKApVLLNqPCL15aQ5fLYi1GP414",
  authDomain: "vuetube-api.firebaseapp.com",
  databaseURL: "https://vuetube-api-default-rtdb.europe-west1.firebasedatabase.app",
  projectId: "vuetube-api",
  storageBucket: "vuetube-api.appspot.com",
  messagingSenderId: "196180385353",
  appId: "1:196180385353:web:6f291287a7ae1d25b52998"
}
firebase.initializeApp(firebaseConfig)

// utils
const db = firebase.firestore()
const auth = firebase.auth()

// collection references
const usersCollection = db.collection('users')
const postsCollection = db.collection('posts')
const commentsCollection = db.collection('comments')
const likesCollection = db.collection('likes')

// export utils/refs
export {
  db,
  auth,
  usersCollection,
  postsCollection,
  commentsCollection,
  likesCollection
}
